import React from "react";
import ProductPage from "../../components/ProductPages/ProductPage";
import { PRODUCT_SCREENSHOTS } from "../../components/ProductPages/productScreenshots";
import {
  generateBreadcrumbStructuredData,
  generateWebPageStructuredData,
} from "../../components/SEO/StructuredData";
import { aiAssistImport } from "../../utility/aiAssistCopy";

const page = aiAssistImport("averages");

const DESCRIPTION =
  "Stop typing every league average by hand. Upload a photo or PDF, review the rows, and use them on the tournament. Free on your first tournament, then AI Assist.";

const SECTIONS = [
  {
    title: "Typing every average takes all night",
    body: "You have a stack of league sheets. Someone has to type every name and average before you can build teams. One wrong number follows that bowler all weekend.",
  },
  {
    title: "Upload the sheet, then review the rows",
    body: "Take a photo or PDF of the league sheet and upload it. The import fills the rows for you. You still open the list, correct a name or average, and keep only what you trust.",
  },
  {
    title: "Use the list when you build the tournament",
    body: "Once the rows look right, use that list when you set averages for the tournament. You still verify a bowler when you need to. Rules that need a minimum games count still use the highest average that meets that rule.",
  },
  {
    id: "plans",
    title: "Free on your first tournament",
    body: "Average import is free on your first tournament. After that it is part of AI Assist.",
    to: "/pricing",
    linkLabel: "Plans",
  },
];

const BowlingTournamentAverageImport = () => (
  <ProductPage
    title={page.title}
    description={DESCRIPTION}
    keywords={[
      "AI average import bowling",
      "import league averages from a photo",
      "bowling tournament average import",
      "league sheet import",
      "AI Assist",
    ]}
    canonicalUrl="/bowling-tournament-average-import"
    kicker="AI Assist"
    heading={page.heading}
    lede={page.lede}
    screenshot={PRODUCT_SCREENSHOTS[page.pageShotKey]}
    analyticsLocation="product_average_import"
    sectionHeading="From a stack of sheets to a list you can trust"
    sections={SECTIONS}
    secondaryTo="/pricing"
    secondaryLabel="Plans"
    structuredData={generateWebPageStructuredData({
      name: page.title,
      description: DESCRIPTION,
      url: "/bowling-tournament-average-import",
      dateModified: "2026-11-04",
    })}
    additionalStructuredData={[
      generateBreadcrumbStructuredData([
        { label: "Home", path: "/" },
        { label: "Averages", path: "/bowling-tournament-averages" },
        {
          label: "Average import",
          path: "/bowling-tournament-average-import",
        },
      ]),
    ]}
  />
);

export default BowlingTournamentAverageImport;
